
import { Model } from "@/utils/models/model";
import { TotalColumn } from "@/utils/views/total-column";
import Vue from "vue";
import AppColumnSelect from "@/components/models/ColumnSelect.vue";
import { browseFieldPathToFilterFieldPath, filterFieldPathToBrowseFieldPath } from "@/utils/models/utils";
import { Browse } from "@/models/browse";

export default Vue.extend({
	props: {
		column: {
			type: Object as ()=>TotalColumn,
			required: true
		},
		model: {
			type: Object as ()=>Model,
			required: true
		},
		browse: {
			type: Object as ()=>Browse,
			required: true,
		},
		canDelete: Boolean,
		isEditing: Boolean
	},
	computed: {
		icon():string{
			if (this.column.IsNegative){
				return "minus";
			}
			return "plus";
		},
		columnName():string{
			let field = this.model.getField(this.col);
			if (!field) {
				return "choose-column";
			}
			return `models.friendlyNames.${field.modelName}.${this.col.split(".").pop()}`;
		},
		col():string {
			return filterFieldPathToBrowseFieldPath(this.column.Column);
		}
	},
	methods: {
		edit(){
			this.$emit("edit");
		},
		remove(){
			this.$emit("delete");
		},
		setColumn(val:string){
			this.column.Column = browseFieldPathToFilterFieldPath(val);
		}
	},
	components: {
		AppColumnSelect
	},
	i18nEx: {
		componentPrefix: "components.view-editor"
	}
});
